import { Search, RotateCcw } from "lucide-react";
import "./FoodFilterBar.css";

function FoodFilterBar({
    foods = [],
    filters,
    setFilters,
}) {

    const categories = [...new Set(
        foods
            .map(food => food.category)
            .filter(Boolean)
    )];

    const providers = [...new Set(
        foods
            .map(food => food.providerId?.businessName)
            .filter(Boolean)
    )];

    const handleChange = (key, value) => {

        setFilters(prev => ({
            ...prev,
            [key]: value,
        }));

    };

    const handleReset = () => {

        setFilters({
            search: "",
            category: "",
            provider: "",
            foodType: "",
            available: "",
        });

    };

    return (

        <div className="food-filter-bar">

            <div className="food-search-box">

                <Search size={18} />

                <input
                    type="text"
                    placeholder="Search food or provider..."
                    value={filters.search}
                    onChange={(e) =>
                        handleChange("search", e.target.value)
                    }
                />

            </div>

            <select
                value={filters.category}
                onChange={(e) =>
                    handleChange("category", e.target.value)
                }
            >
                <option value="">All Categories</option>

                {categories.map(category => (

                    <option
                        key={category}
                        value={category}
                    >
                        {category}
                    </option>

                ))}

            </select>

            <select
                value={filters.provider}
                onChange={(e) =>
                    handleChange("provider", e.target.value)
                }
            >
                <option value="">All Providers</option>

                {providers.map(provider => (

                    <option
                        key={provider}
                        value={provider}
                    >
                        {provider}
                    </option>

                ))}

            </select>

            <select
                value={filters.foodType}
                onChange={(e) =>
                    handleChange("foodType", e.target.value)
                }
            >
                <option value="">Food Type</option>
                <option value="Veg">Veg</option>
                <option value="Non Veg">Non Veg</option>
            </select>

            <select
                value={filters.available}
                onChange={(e) =>
                    handleChange("available", e.target.value)
                }
            >
                <option value="">Status</option>
                <option value="true">Available</option>
                <option value="false">Unavailable</option>
            </select>

            <button
                className="reset-filter-btn"
                onClick={handleReset}
            >
                <RotateCcw size={18} />
                Reset
            </button>

        </div>

    );

}

export default FoodFilterBar;